import React, { useEffect, useState } from 'react';
import Logo from './Logo';

const NAV = [
  { label: 'Product', href: '/#features' },
  { label: 'How it works', href: '/#how' },
  { label: 'Integrations', href: '/#integrations' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'FAQ', href: '/#faq' },
];

const SiteHeader: React.FC = () => {
  const webappUrl =
    process.env.REACT_APP_PABSYNC_WEBAPP_URL || 'https://app.pabsync.com';
  const signupUrl = `${webappUrl}/register?plan=free&src=website`;

  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll when the mobile drawer is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
      <div className="container nav__inner">
        <a className="nav__brand" href="/" aria-label="PabSync home">
          <Logo size={30} />
        </a>

        <nav className="nav__links" aria-label="Primary">
          {NAV.map((item) => (
            <a key={item.label} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="nav__actions">
          <a className="nav__login" href={webappUrl}>
            Log in
          </a>
          <a className="btn btn--primary btn--sm" href={signupUrl}>
            Start free
          </a>
        </div>

        <button
          className="nav__toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className={`nav__toggle-bar${open ? ' is-open-1' : ''}`} />
          <span className={`nav__toggle-bar${open ? ' is-open-2' : ''}`} />
          <span className={`nav__toggle-bar${open ? ' is-open-3' : ''}`} />
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`nav__drawer${open ? ' is-open' : ''}`}
        role="dialog"
        aria-modal="true"
        hidden={!open}
      >
        <nav className="nav__drawer-links" aria-label="Mobile">
          {NAV.map((item) => (
            <a key={item.label} href={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
        </nav>
        <div className="nav__drawer-actions">
          <a className="btn btn--ghost" href={webappUrl}>
            Log in
          </a>
          <a className="btn btn--primary" href={signupUrl}>
            Start free
          </a>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
